import React from 'react'
import { connect } from 'react-redux'
import Datetime from 'react-datetime'
import moment from 'moment'

import { lngIso } from 'commons'
import { dateFormat } from '../../../helpers/formatters'
import { updateShortEndDate, getShortDateRange } from '../../../store/dateRange'

const DateRangeShortEndDate = ({ dispatch, dateRange, lng }) => {
  const format = dateFormat()

  function onChange(date) {
    const isValid = moment(date, format, true).isValid()
    if (!isValid) return
    dispatch(updateShortEndDate(date))
  }

  return (
    <Datetime
      id="endDate"
      locale={lng}
      closeOnSelect
      dateFormat={dateFormat()}
      timeFormat={false}
      value={moment(dateRange.endDate).toDate()}
      onChange={onChange}
    />
  )
}

const mapStateToProps = (state) => ({
  dateRange: getShortDateRange(state),
  lng: lngIso(state),
})

export default connect(mapStateToProps)(DateRangeShortEndDate)
